import { DataGrid } from '@celltrak/ui-components';

import { text } from '../../constants';

import { visitsListHeaders } from './gridDefinitions';
import useVisitsList from './hooks';
import styles from './VisitsList.module.scss';

function VisitsList() {
  const {
    handleRowClick,
    activeRow,
    handleColumnClick,
    sortByColumn,
    sortDirection,
    isLoading,
    visitsRows,
  } = useVisitsList();

  return (
    <div className={styles.gridContainer}>
      <DataGrid
        rows={visitsRows}
        headers={visitsListHeaders}
        fullWidth
        loading={isLoading}
        onRowClick={handleRowClick}
        selectedRow={activeRow}
        onColumnClick={handleColumnClick}
        sortByColumn={sortByColumn}
        sortDirection={sortDirection}
        noDataMessage={text.noDataMessage}
      />
    </div>
  );
}

export default VisitsList;
